import { AddressLink, DaoOnChainReportSaleResultCall } from 'Modules'

import { usePreparedTx } from 'hooks/dao-voting/use-prepared-tx'

/**
 * AssetStateMachine on-chain writes (SRS 5.8).
 * The BE prepares the calldata (reportSaleResult, reportHolding, ...) for the
 * state machine address it returns - PTO NFT or ERC-3643; the manager wallet
 * sends it as is.
 */
export const useAssetStateMachineContract = () => {
  const { sendPreparedTx } = usePreparedTx()

  const sendPreparedCall = async (address: AddressLink, call: DaoOnChainReportSaleResultCall) => {
    if (!call?.contractAddress) throw new Error('Asset state machine address is missing')
    if (!call?.calldata) throw new Error('On-chain calldata is missing')

    return sendPreparedTx(address, { to: call.contractAddress, data: call.calldata })
  }

  return {
    /** reportSaleResult(collection, success) - SRS 5.8 Report Sale Result */
    reportSaleResultOnChain: sendPreparedCall,
    /** reportHolding(collection) - SaleFailed -> Holding (Update Status) */
    reportHoldingOnChain: sendPreparedCall,
  }
}
